import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HeaderPlaylist } from './../component/headerPlaylist';
import { fetchPlaylist, fetchFootermenu } from './../actions';
import {
  fetchFooterStaticText,
  fetchStaticText,
} from './../../ui/src/actions.js';
import { PlaylistItem } from './../component/playlistItem';
import { CircleImageTitle } from './../component/circleImageTitle';
import { CsmArticleContent } from './../../ui/src/component/csmArticle';
import { calendarTime } from './../../ui/src/utilities.js';
import noImg from './../../assets/no-image-small.png';
import Api from './../../ui/src/api.js';
import { Modal } from './../../ui/src/component/modal';
import moment from 'moment';
import Banner from "../component/banner";
import Footer from '../component/footer/footer';

class Playlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feed: [],
      modalOpened: false,
      youtubeUrl: null,
      youtubeTitle: null,
    };
    this.playlistInterval = null;
  }

  componentDidMount() {
    this.fetchPlaylist();
    this.props.dispatch(fetchFootermenu());
    this.props.dispatch(
      fetchFooterStaticText(
        process.env.REACT_APP_CONTENT_SPACE,
        'text-v-pate-stranky',
      ),
    );
    this.props.dispatch(
      fetchStaticText(
        process.env.REACT_APP_CONTENT_SPACE,
        'PLAYLIST_BANNER',
        'bannery-v-playliste',
      ),
    );
    this.playlistInterval = setInterval(() => {
      this.fetchPlaylist();
    }, 30000);
  }

  fetchPlaylist() {
    this.props
      .dispatch(
        fetchPlaylist({
          limit: 22,
        }),
      )
      .then(response => {
        Api.get('/cm/public/feed', {
          limit: this.props.playlist.length - 1,
        }).then(response => {
          this.setState({ feed: response.feed });
        });
      });
  }

  componentWillUnmount() {
    clearInterval(this.playlistInterval);
  }

  render() {
    let [currentItem] = this.props.playlist.slice(0, 1);
    let otherItems = this.props.playlist.slice(1);
    const date = new Date();
    return (
      <div>
        <div>
          <div className="container">
            <Banner
                id="banner-radiokosice-sk-uplne-na-vrchu"
                autoReload={true}
                location={this.props.location}
            />
          </div>
        </div>
        {currentItem ? (
          <HeaderPlaylist
            currentlyPlayingItem={currentItem}
            onClickYoutube={youtubeObject => {
              this.setState({
                modalOpened: true,
                youtubeUrl: youtubeObject.embedurl,
                youtubeTitle: youtubeObject.title,
              });
            }}
            forcePausePlayer={this.state.modalOpened}
          />
        ) : null}
        <div className="container-fluid bg-alt-light">
          <div className="row">
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-playlist">
                  <div className="row">
                    <div className="col-sm-6">
                      <h1>Playlist</h1>
                      {otherItems.map((item, idx) => {
                        return (
                          <PlaylistItem
                            key={idx}
                            item={item}
                            onClickYoutube={youtubeObject => {
                              this.setState({
                                modalOpened: true,
                                youtubeUrl: youtubeObject.embedurl,
                                youtubeTitle: youtubeObject.title,
                              });
                            }}
                          />
                        );
                      })}
                    </div>
                    <div className="col-sm-6">
                      <h2 className="h1">Aktuálne</h2>
                      {this.state.feed.map(item => {
                        return (
                          <a
                            key={item._id}
                            href={item.url}
                            target="_blank"
                            className="article"
                          >
                            <CircleImageTitle
                              image={item.picture ? item.picture : noImg}
                              title={<strong>{item.title}</strong>}
                              subtitle={item.author}
                              time={calendarTime(
                                moment(item.content_datetime),
                                false,
                              )}
                            />
                          </a>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-playlist-ads">
                  {this.props.playlistBannerStaticText && (
                    <CsmArticleContent
                      content={this.props.playlistBannerStaticText}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.modalOpened}
          onHide={() => this.setState({ modalOpened: false })}
        >
          {/* Cele to musime oddrbat z DOM-u, pretoze sa moze stat, ze youtube video pokracuje v hrani ked sa modal zavrie */}
          {this.state.modalOpened && (
            <div>
              <div className="modal-header">
                <button
                  type="button"
                  onClick={() => this.setState({ modalOpened: false })}
                  className="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 className="modal-title">{this.state.youtubeTitle}</h4>
              </div>
              <div className="modal-body">
                <iframe
                  title="youtube-video"
                  width="560"
                  height="315"
                  src={`${this.state.youtubeUrl}?autoplay=1`}
                  allowFullScreen={1}
                  frameBorder={0}
                />
              </div>
            </div>
          )}
        </Modal>
        <Footer
          linksTarget="_blank"
          nav={this.props.footermenu}
          content={this.props.footerStaticText}
          copyrightText={`2007-${date.getFullYear()} © MARK MEDIA s.r.o.`}
          facebookUrl="https://www.facebook.com/RadioKosice/"
        />
      </div>
    );
  }
}

Playlist.propTypes = {
  alert: PropTypes.object,
  loading: PropTypes.number.isRequired,
  playlist: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  footermenu: PropTypes.array.isRequired,
  footerStaticText: PropTypes.object,
  playlistBannerStaticText: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    alert: state.alert,
    loading: state.loading,
    playlist: state.playlist.data.items,
    footermenu: state.footermenu.data.sections,
    footerStaticText: state.footerStaticText.data.content,
    playlistBannerStaticText: state.playlistBannerStaticText.data.content,
  };
};

export default connect(mapStateToProps)(Playlist);



// WEBPACK FOOTER //
// ./src/app/container/playlist.js